<template>
  <app-content>
    <app-content-body>

      <div class="inner">
        <p class="buttons">
          <a
              class="btn btn_action btn_add"
              title="Vytvořit video"
              @click.prevent="createItem"
          >Vytvořit video</a>
        </p>
        <h1 v-translate>Videa</h1>
      </div>

      <app-table
              clickable
              deletable
              :data="items"
              :highlight-rows-on-hover="true"
              :order="params.order"
              :page-size="params.limit"
              @sort="sortItems"
              @rowClick="goToDetail"
              @deleteRow="deleteItem"
              :loading="pending"
      >
        <template slot="header">
          <app-table-header-item class="field_left">
            <app-input
                :label="translations.search"
                name="search"
                type="search"
                v-model="search"
            />
            <app-table-header-select :label="translations.providerName">
                <app-select
                    :options="providerSelectOptions"
                    v-model.trim="params.idProvider"
                    @change="fetchItems(true)"
                />
            </app-table-header-select>
          </app-table-header-item>
          <app-table-header-item class="field_right">
            <app-table-header-select :label="translations.active">
                <app-select
                    :options="activeSelect"
                    v-model.trim="params.active"
                    @change="fetchItems(true)"
                />
            </app-table-header-select>
              <app-table-header-select :label="translations.state">
                  <app-select
                      :options="stateSelect"
                      v-model.trim="params.state"
                      @change="fetchItems(true)"
                  />
              </app-table-header-select>
          </app-table-header-item>
        </template>

        <app-table-column first sortable attribute="name" :label="translations.name">
          <template slot-scope="row">
            <strong>
              <div v-html="row.name" :title="row.episodeName" />
            </strong>
              {{ getEpisodeNumericTitle(row) }}
          </template>
        </app-table-column>
        <app-table-column sortable attribute="showName" :label="translations.showName">
          <template slot-scope="row">
              <div v-html="row._showName" />
          </template>
        </app-table-column>
        <app-table-column attribute="_packageNames" :label="translations.packagesName">
          <template slot-scope="row">
              <div v-html="row._packageNames.join(', ')" />
          </template>
        </app-table-column>
        <app-table-column sortable attribute="providerName" :label="translations.providerName">
          <template slot-scope="row">
              <div v-html="row._providerName" />
          </template>
        </app-table-column>
        <app-table-column sortable attribute="active" :label="translations.active">
          <template slot-scope="row">
              <app-graphic-image :value="row.active" />
          </template>
        </app-table-column>
        <app-table-column attribute="state" :label="translations.state">
            <template slot-scope="row">
                <div v-if="row._state === 'WAITING'" style="color: gray;">
                    {{ translations.waiting }}
                </div>
                <div v-else-if="row._state === 'READY'" style="color: green;">
                    {{ translations.ready }}
                </div>
                <div v-else-if="row._state === 'FAILED'" style="color: red;">
                     <strong>{{ translations.failed }}</strong>
                </div>
                <div v-else>
                    {{ row._state }}
                </div>
            </template>
        </app-table-column>
        <app-table-column sortable attribute="created" :label="translations.created">
          <template slot-scope="row">
            <div v-html="formatDate(row._created)" />
          </template>
        </app-table-column>

        <template slot="footer" v-if="itemsMetadata.totalCount > params.limit">
          <app-table-pagination
              :page="listPage"
              :itemsPerPage="params.limit"
              :totalCount="itemsMetadata.totalCount"
              @pageChanged="tablePageChanged"
          />
        </template>
      </app-table>
    </app-content-body>
  </app-content>
</template>

<script>
import getItemsListMixin from 'mixins/getItemsListMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'

const itemsListMixin = getItemsListMixin({
  apiMethodsSuffix: 'Videos',
  detailRouteName: 'vodVideo'
})

import { mapActions, mapState } from 'vuex'

export default {
  name: 'currency-items',
  mixins: [formatDateMixin, itemsListMixin, appTitleMixin(['Videa'])],
  data() {
    return {
      search: ''
    }
  },
  created() {
    this.search = this.params.search

    this.getProviders({params: { order: 'name' }});
  },
  computed: {
    ...mapState({
        providers: state => state['providers']['providers'],
    }),
    translations() {
      return {
        active: this.$gettext('Aktivní'),
        search: this.$gettext('Vyhledávání'),
        state: this.$gettext('Stav'),
        name: this.$gettext('Název'),
        created: this.$gettext('Založeno'),
        showName: this.$gettext('Název pořadu'),
        packagesName: this.$gettext('Balíčky'),
        providerName: this.$gettext('Poskytovatel'),
        waiting: this.$gettext('Čeká...'),
        ready: this.$gettext('Připraveno'),
        failed: this.$gettext('CHYBA'),
      }
    },
    currentTitle() {
      return [
        this.$gettext('Videa')
      ]
    },
    activeSelect() {
      return [
          { name: this.$gettext('Nevybráno'), value: null },
          { name: this.$gettext('Ano'), value: true },
          { name: this.$gettext('Ne'), value: false }
      ]
    },
    stateSelect() {
        return [
            { name: this.$gettext('Nevybráno'), value: null },
            { name: 'WAITING', value: 'WAITING' },
            { name: 'READY', value: 'READY' },
            { name: 'FAILED', value: 'FAILED' },
        ]
    },
    providerSelectOptions() {
        return [
            { name: this.$gettext(''), value: null },
            ...this.providers.map(v => ({ name: v.name, value: v._id }))
        ]
    }
  },
  methods: {
    ...mapActions(['getProviders']),
    shouldRefreshAfterDelete() {
      return true
    },
    getEpisodeNumericTitle(videoRow) {
        if (videoRow.episodeNumber && videoRow.seasonNumber) {
            return " [Episode: " + videoRow.episodeNumber + " | Season: " + videoRow.seasonNumber + "]";
        } else if (videoRow.episodeNumber) {
            return " [Episode: " + videoRow.episodeNumber + "]";
        } else if (videoRow.seasonNumber) {
            return " [Season: " + videoRow.seasonNumber + "]";
        } else {
            return "";
        }
    }
  },
  watch: {
    search: function (newVal, oldVal) {
      if (newVal.length >= 2) {
          this.params.search = this.search
          this.fetchItems()
      } else if (newVal.length < 2 && oldVal.length >= 2) {
          this.params.search = ''
          this.fetchItems()
      }
    }
  }
}
</script>
